<template>
  <div>
    <el-tabs
      v-model="activeName"
      type="card"
    >
      <el-tab-pane
        label="关键点控制"
        name="first"
      >
        <KeyPoints />
      </el-tab-pane>
      <el-tab-pane
        label="检验项"
        name="second"
      >
        <Inspection />
      </el-tab-pane>
      <el-tab-pane
        label="溯源模板"
        name="third"
      >
        <TracingSource />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import KeyPoints from './components/KeyPoints'
import Inspection from './components/Inspection'
import TracingSource from './components/TracingSource'

export default {
  components: {
    KeyPoints,
    Inspection,
    TracingSource
  },
  data() {
    return {
      activeName: 'first'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
